var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-button"},[_c('button',{staticClass:"button button--black no-wrap",attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('downloadClicked')}}},[_vm._v("\n\t\t"+_vm._s(_vm.buttonText)+"\n\t\t"),_c('span',{staticClass:"icon icon-download",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }